import React from 'react';
import { styled } from '@mui/material/styles';

const ActiveAbsolute = styled('div', {
  shouldForwardProp: (prop) => prop !== 'height',
})(({ theme, height }) => ({
  position: 'absolute',
  height: 'calc(100% - 130px)',
  width: 'calc(100% - 316px)',
  overflow: 'auto',
  padding: theme.spacing(1),

  [theme.breakpoints.down('xl')]: {
    paddingLeft: '0',
    paddingRight: '0',
    width: '100%',
    height: height || window.innerHeight - 194,
  },
  [theme.breakpoints.down('lg')]: {
    position: 'relative',
    height: '100%',
    overflow: undefined,
  },

  '@media print': {
    position: 'relative',
    width: '100%',
    height: '100%',
  },
}));

const Active = styled('div')(({ theme }) => ({
  padding: theme.spacing(1),
  textAlign: 'center',
  [theme.breakpoints.down('xl')]: {
    paddingLeft: '0',
    paddingRight: '0',
  },
  [theme.breakpoints.down('lg')]: {
    position: 'relative',
    width: '100%',
    height: '100%',
    overflow: undefined,
  },
  '& > div': {
    textAlign: 'initial',
  },
}));

export default function TabContainer(props) {
  const Comp = props.useAbsolute ? ActiveAbsolute : Active;
  return (
    <Comp id="ActiveAbsolute" height={props.height}>
      {props.children}
    </Comp>
  );
}
